module.exports = __webpack_public_path__ + "static/media/vicky.deb14075.jpeg";